import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { MFileDisplayComponent } from './file-display.component';
import { MFileIconComponent } from './file-icon.component';
import { MFileItemComponent } from './file-item.component';
@NgModule({
  declarations: [MFileDisplayComponent, MFileItemComponent, MFileIconComponent],
  exports: [MFileDisplayComponent, MFileItemComponent, MFileIconComponent],
  imports: [CommonModule, NzCheckboxModule, FormsModule, NzIconModule, NzProgressModule, NzInputModule, NzEmptyModule, NzButtonModule]
})
export class MFileDisplayModule {}
